import { AfterContentInit, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { UsuarioAutorizacoes } from 'src/app/models/usuario.autorizacoes.model';
import { GrupoLocalNivelService } from 'src/app/services/grupo-local-nivel.service';
import { UsuarioService } from 'src/app/services/usuario.service';
import Swal from 'sweetalert2';
import { CommandResult } from '../../domain/commandResult';
import { GrupoLocalNivel1 } from '../../domain/domain.model';



@Component({
  selector: 'app-grupo-local-nivel',
  templateUrl: './grupo-local-nivel.component.html',
  styleUrls: ['./grupo-local-nivel.component.scss']
})
export class GrupoLocalNivelComponent implements OnInit, AfterContentInit {

  constructor(
    private usuarioService: UsuarioService,
    private formBuilder: FormBuilder,
    private grupoLocalNivelService: GrupoLocalNivelService,
    private toastr: ToastrService,
  ) { }


  public cadastrados: GrupoLocalNivel1[] = []; // Lista de Grupos Local nível cadastrados
  public form: FormGroup = null;

  public isEditing = false;
  public isProcessing = false;
  public isLoadingCadastrados = false;

  public autorizacoes: UsuarioAutorizacoes;

  public totalNiveis2 = 0;
  public totalNiveis3 = 0;

  ngAfterContentInit(): void {
    this.autorizacoes = this.usuarioService.getAutorizacoesJanelaPorRota('grupo-local-nivel');
  }

  ngOnInit() {

    this.getCadastrados();
    this.resetForm(); // instancia o formulário utilizado (formGroup)
  }

  getCadastrados() {
    this.isLoadingCadastrados = true;
    this.grupoLocalNivelService.getAllGrupoLocalNivel1().subscribe(
      (response: GrupoLocalNivel1[]) => {
        this.cadastrados = response;
        this.isLoadingCadastrados = false;
      }
    );
  }


  public resetForm(): void {
    this.form = this.formBuilder.group(
      {
        id: [0],
        nome: [null, [Validators.required, Validators.maxLength(90)]]
      }
    );
  }

  public reset(): void {
    this.isEditing = false;
    this.isProcessing = false;
    this.isLoadingCadastrados = false;
    this.resetForm();
  }


  public getById(id: number): void {

    this.reset();
    this.isProcessing = true;
    this.isEditing = true;

    this.grupoLocalNivelService.getById(id).subscribe(
      (response: GrupoLocalNivel1) => {
          this.form.patchValue({
            id: response.id,
            nome: response.nome
          });
          this.isProcessing = false
      },
      (exception: any) => {
        const cmdResult = new CommandResult(false, '', [], null);
        cmdResult.showErrorExecption(exception);
        this.isProcessing = false
      },
      () => this.isProcessing = false
      )

  }

  public submit(): void {

    this.isProcessing = true;
    
    this.grupoLocalNivelService.post(this.form.value as GrupoLocalNivel1).subscribe(

      (response: CommandResult) => {
        if (response.success === true) {
          this.toastr.success(response.message);
          this.reset();
          this.getCadastrados();
        } else {
          this.toastr.error(response.message);
        }
      },
      (exception: any) => {
        this.showErrorExecption(exception);
        this.isProcessing = false
      },
      () => this.isProcessing = false

    );

  }


  public questionDelete(id: number) {

    Swal({
      title: 'Excluir',
      text: 'Deseja excluir o item selecionado?',
      type: 'question',
      showCancelButton: true,
      cancelButtonText: 'Não',
      showConfirmButton: true,
      confirmButtonText: 'Sim',
      cancelButtonColor: '#d33',
      focusCancel: true
    }).then((result) => {
      if (result.value) {
        this.delete(id);
      }
    });

  }



  private delete(id: number): void {

    this.isProcessing = true;

    this.grupoLocalNivelService.delete(id).subscribe(

      (response: CommandResult) => {

        const cmdResult = new CommandResult(response.success, response.message, response.notifications, response.data);

        if (cmdResult.success === true) {
          this.toastr.success(cmdResult.message);
          this.reset();
          this.getCadastrados();
        } else {
          this.toastr.warning(cmdResult.message);
        }
      },
      (exception: any) => {
        const cmdResult = new CommandResult(false, '', [], null);
        cmdResult.showErrorExecption(exception);
      },

      () => this.isProcessing = false

    );
  }

  private showErrorExecption(exception: any) {
    let msg = exception.message;
    if (Number(exception.status) === 0) { msg = 'A aplicação não conseguiu se conectar ao Servidor'; }
    if (Number(exception.status) === 500) { msg = 'O Servidor gerou um erro de processamento'; }
    this.toastr.error(`<b>Erro no Servidor</b><br /><br />status: <b>${exception.status}</b><br /><br />${msg}`);
  }

}
